import React from 'react';
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';
import MainPage from '../main-page/main-page';
import UserSideBar from '../user/sidebar/sidebar';
import BackOfficeSideBar from '../back-office/sidebar/sidebar';
import UserSignIn from '../user/signin/signin';
import BackOfficeSignIn from '../back-office/signin/signin';
import BackOfficeUsers from '../back-office/users/users';
import BackOfficeNewsletters from '../back-office/newsletters/newsletters';
import BackOfficeInterests from '../back-office/interests/interests';
import BackOfficeReports from '../back-office/reports/reports';
import CompleteProcess from '../complete-process/complete-process';
import UserInterests from '../user/interests/interests';
import UserSettings from '../user/settings/settings';
import UserForgotPassword from '../user/forgot-password/forgot-password';
import UserNewPassword from '../user/new-password/new-password';

function Menu() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<MainPage />} />
        <Route path='/complete-process' element={<CompleteProcess />} />
        <Route path='/user/forgot-password' element={<UserForgotPassword />} />
        <Route path='/user/new-password' element={<UserNewPassword />} />
        <Route path='/user' element={<UserSideBar />}>
          <Route path='signin' element={<UserSignIn />} />
          <Route path='interests' element={<UserInterests />} />
          <Route path='settings' element={<UserSettings />} />
        </Route>
        <Route path='/back-office' element={<BackOfficeSideBar />}>
          <Route path='signin' element={<BackOfficeSignIn />} />
          <Route path='users' element={<BackOfficeUsers />} />
          <Route path='interests' element={<BackOfficeInterests />} />
          <Route path='newsletters' element={<BackOfficeNewsletters />} />
          <Route path='reports' element={<BackOfficeReports />} />
        </Route>
      </Routes>
      <Outlet />
    </BrowserRouter>
  );
}

export default Menu;
